module.exports = __webpack_public_path__ + "img/clocks.0c943e90.svg";